export default async function signOut(isAlternateLogin) {
	let url = `${process.env.REACT_APP_API_URL}logout?alternate=${isAlternateLogin ? 'true' : 'false'}`;

	const response = await fetch(url, {
		method: 'POST',
		credentials: 'include',
		headers: {
			'Content-Type': 'application/json',
		}
	})

	if (response.status === 200) {
		return;
	} else {
		throw response.statusText;
	}
};